<template>
    <div class="space-y-4">
        <H1>Heading 1</H1>
        <H2>Heading 2</H2>
        <H3>Heading 3</H3>
        <H4>Heading 4</H4>
        <P>
            The king, seeing how much happier his subjects were, realized the error of
            his ways and repealed the joke tax. This is a paragraph.
        </P>

        <Blockquote>This is a blockquote.</Blockquote>

        <Lead>
            This is lead text.
        </Lead>

        <Muted>
            This is muted text.
        </Muted>

        <Large>This is large text.</Large>

        <Small>This is small text.</Small>
    </div>
</template>

<script lang="ts" setup>

</script>